"use client";

import { useTranslations } from "@/i18n/LocaleProvider";
import { LOCALES } from "@/i18n/locales";

// Hidden while there's only one locale to choose from -- reappears on its own the moment a
// second dictionary is added to i18n/dictionaries.ts, no other change needed.
export default function LanguageSwitcher() {
  const { locale, setLocale, t } = useTranslations();

  if (LOCALES.length < 2) return null;

  return (
    <label className="text-sm">
      <span className="sr-only">{t("languageSwitcher.label")}</span>
      <select
        value={locale}
        onChange={(e) => setLocale(e.target.value)}
        className="rounded-full border border-foreground/20 bg-transparent px-3 py-1.5 text-sm font-medium"
      >
        {LOCALES.map((l) => (
          <option key={l.code} value={l.code} title={l.label}>
            {l.code.toUpperCase()}
          </option>
        ))}
      </select>
    </label>
  );
}
